<template>
  <router-view :req.sync="req"/>
</template>

<script>
export default {
  name: 'RequestPasswordReset',
  data() {
    return {
      req: {
        editState: 'editing'
      }
    }
  }
}
</script>

<style scoped>
</style>